// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2vE-p","footer":"Form_footer__2bwtO"};